import { render, staticRenderFns } from "./ReviewImages.vue?vue&type=template&id=65bf5c4e&scoped=true"
import script from "./ReviewImages.vue?vue&type=script&lang=js"
export * from "./ReviewImages.vue?vue&type=script&lang=js"
import style0 from "./ReviewImages.vue?vue&type=style&index=0&id=65bf5c4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bf5c4e",
  null
  
)

export default component.exports